import {
  BooleanInput,
  NumberInput,
  SimpleForm,
  SimpleFormProps,
  TextInput,
  required
} from 'react-admin';
import { UploadImageInput } from '../../components';
import UploadInput from '../../components/UploadInput';

export default function TimelineItemsForm(props: Partial<SimpleFormProps>) {
  return (
    <SimpleForm {...props} redirect="list">
      <NumberInput
        fullWidth
        autoComplete="off"
        label="Ano"
        source="year"
        validate={[required()]}
      />

      <TextInput
        fullWidth
        autoComplete="off"
        label="Título"
        source="title"
        validate={[required()]}
      />

      <TextInput
        fullWidth
        autoComplete="off"
        label="Descrição"
        source="description"
      />

      <UploadInput
        fullWidth
        label="Ícone"
        source="icon"
        mimeTypes={['.svg']}
        helperText="É possível enviar imagens no formato SVG."
        validate={[required()]}
      />

      <UploadImageInput
        fullWidth
        label="Imagem"
        source="image"
        mimeTypes={['image/jpeg']}
        upploadOptions={{
          maxSize: [616, 382]
        }}
        helperText="É possível enviar imagens no formato JPEG com dimensões recomendadas de 616x382px."
      />

      <BooleanInput label="Ativo" source="active" defaultValue />
    </SimpleForm>
  );
}
